<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}

.branch-select {
    min-width: 200px
}

.loading-hiden {
    display: none;
}

.loading-show {
    display: contents;
}

.first {
    float: left;
    margin-right: 1em;
}

.price {
    float: right;
    margin-left: 1em;
}

.list:after {
    content: '';
    border-bottom: dotted;
    display: block;
    overflow: hidden;
    height: 0.6em;
}

#invoice-POS {
    box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
    padding: 2mm;
    margin: 0 auto;
    width: 80mm;
    background: #FFF;

}

h1 {
    font-size: 1.5em;
    color: #222;
}

h2 {
    font-size: .9em;
}

h3 {
    font-size: 1.2em;
    font-weight: 300;
    line-height: 2em;
}

p {
    font-size: 13px;
    color: #000;
    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
    /*font-family: 'JuneBug';*/
    /*line-height: 1.2em;*/
}

#top,
#mid,
#bot {
    /* Targets all id with 'col-' */
    border-bottom: 1px solid #EEE;
}

#top {
    min-height: 100px;
}

#mid {
    min-height: 80px;
}

#bot {
    min-height: 50px;
}

.info {
    display: block;
    float: left;
    margin-left: 0;
}

.title {
    float: right;
}

.title p {
    text-align: right;
}

table {
    width: 100%;
    border-collapse: collapse;
}

td {
    padding: 5px 0 5px 15px;
    border: 1px solid #EEE
}

.tabletitle {
    padding: 5px;
    font-size: .5em;
    background: #EEE;
}

.service {
    border-bottom: 1px solid #EEE;
}

.item {
    width: 24mm;
}

.itemtext {
    font-size: .5em;
}

#legalcopy {
    margin-top: 5mm;
}

.hh_p {
    font-size: 14px !important;
}

.head-text {
    /*font-size: 30px;*/
    font-weight: 600;
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-12 col-xl-8 mb-4 mb-xl-0">
                        <h3 class="font-weight-bold">Outgoing Parcels</h3>
                    </div>
                    <div class="col-12 col-xl-4">

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">

                <div class="row">
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                        <input class="date_input form-control" v-model="this.fdate" type="date">
                    </div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                        <input class="date_input form-control" type="date" v-model="this.tdate">
                    </div>
                    <div class="col-sm-4 col-md-3 col-6 stretch-card col-grid">
                        <div class="d-flex w-100">
                            <input type="text" v-model="this.filter_branch" style="width: 100px !important;"
                                class="form-control" placeholder="Filter">
                            <select v-model="branch_from" class="form-select form-control">
                                <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                                    {{ branch.name }}
                                </option>
                            </select>

                        </div>
                    </div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                        <select v-model="staff_id" class="form-select form-control">
                            <option v-for="staff in staffs" :key="staff.id" :value="staff.id">
                                {{ staff.fulname }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4 col-md-1 col-6 stretch-card col-grid">
                        <button id="filter_btn" @click="filterParcel" class="btn btn-primary simple-btn">Filter</button>
                    </div>
                    <div class="col-sm-4 col-md-1 col-6 stretch-card col-grid">
                        <button v-if="!contact_form" @click="showSMSForm"
                            class="btn btn-success text-white simple-btn">SendSMS</button>
                        <button v-if="contact_form" @click="showSMSForm"
                            class="btn btn-danger text-white simple-btn">CloseSMS</button>
                    </div>
                    <div class="col-sm-4 col-md-1 col-6 stretch-card col-grid">
                        <button id="filter_btn" @click="getPdfModal" class="btn btn-dark simple-btn">PDF</button>
                    </div>
                </div>

                <div v-if="contact_form">
                    <div class="card mt-3">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-7 col-sm-12">
                                    <div class="form-group">
                                        <label for="">Phone numbers (comma separated)</label>
                                        <textarea class="form-control" rows="5" v-model="this.phone_list"></textarea>
                                    </div>
                                </div>
                                <div class="col-md-5 col-sm-12">
                                    <div class="form-group">
                                        <label for="">Message</label>
                                        <textarea class="form-control" v-model="this.message"></textarea>
                                    </div>

                                    <div class="d-flex justify-content-between">
                                        <button class="btn btn-primary" @click="sendSms()">Send SMS</button>
                                        <button class="btn btn-danger text-white" @click="clearPhoneList">Clear
                                            Chat</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="loading" class="mt-1">
                    <div class="text-center">
                        <div class="spinner-grow text-success" role="status"></div>
                        <div class="spinner-grow text-danger" role="status"></div>
                        <div class="spinner-grow text-warning" role="status"></div>
                    </div>
                </div>

                <div class="table-responsive">

                    <table class="table table-striped mt-3">
                        <thead>
                            <tr class="thead-style">
                                <th>No</th>
                                <th> Package Label</th>
                                <th>Price</th>
                                <th>Package Name</th>
                                <th> Receiver name </th>
                                <th> Receiver phone </th>
                                <th> Destination </th>
                                <th> Sender staff </th>
                                <th> Date issue </th>
                                <th> Action </th>
                            </tr>
                        </thead>
                        <tbody id="incoming-list">

                            <tr v-for="(parcel, index) in paginatedParcels" :key="parcel.id" :id="'parcel_' + parcel.id">
                                <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>

                                <td v-if="parcel.package_size == 'S'"><span class="text-success text-small">[S]
                                    </span><span class="text-capitalize">{{ parcel.name }}</span></td>
                                <td v-else><span class="text-danger">[R] </span><span class="text-capitalize">{{
                                        parcel.name }}</span>
                                </td>

                                <td>
                                    <PriceFormat :Price="parcel.price" />
                                </td>
                                <td><label class="badge badge-dark">{{ parcel.package_tag }}</label></td>
                                <td class="text-capitalize"> {{ parcel.receiver_name }} </td>
                                <td> <a class="text-success no-href-dec add_phone"
                                        @click="addPhoneList(parcel.receiver_phone)">{{ parcel.receiver_phone }} <i
                                            class="mdi mdi-message-processing"></i></a></td>
                                <td><label class="badge badge-primary">{{ parcel.bname }}</label></td>
                                <td> <label class="badge badge-success">{{ parcel.fulname }}</label></td>
                                <td>
                                    <DateFormat :Date_="parcel.created_at" />
                                </td>
                                <td>
                                    <button type="button" @click="getReceiveParcel(parcel)"
                                        class="btn receive_btn btn-primary btn-icon">
                                        <i class="mdi mdi-gift"></i>
                                    </button>
                                    <button type="button" @click="getReceiptPackage(parcel)"
                                        class="btn receipt_btn btn-dark btn-icon">
                                        <i class="fa fa-print"></i>
                                    </button>

                                    <button @click="getDeleteParcel(parcel)" v-if="user.role > 1" type="button"
                                        class="remove_btn btn btn-danger text-white btn-icon">
                                        <i class="fa fa-times"></i>
                                    </button>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <div class="pagination-wrapper">

                    <button @click="currentPage--" :disabled="currentPage === 1">
                        Prev
                    </button>

                    <button v-for="page in totalPages" :key="page" @click="currentPage = page"
                        :class="{ active: currentPage === page }">
                        {{ page }}
                    </button>

                    <button @click="currentPage++" :disabled="currentPage === totalPages">
                        Next
                    </button>

                </div>
            </div>
        </div>
    </div>

    <!--receiver -->
    <div class="modal fade mobile-full-width" id="receiveModal" tabindex="-1" data-bs-backdrop="static"
        data-bs-keyboard="false" role="dialog" aria-labelledby="receiveModal" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">

            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="font-weight-bold">Receive Parcels</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="container mt-3 mb-3">
                    <div class="row">

                        <div class="col-sm-12">
                            <h4 class="text-center mt-3">{{ parcel.name }}</h4>
                            <h5 id="">Sender : {{ parcel.sender_name }} - {{ parcel.sender_phone }}</h5>
                            <h5 id="">Receiver : {{ parcel.receiver_name }} - {{ parcel.receiver_phone }}</h5>
                        </div>

                        <div class="col-sm-12 col-md-12">
                            <div class="form-group">
                                <label class="form-label">Comment (option)</label>
                                <textarea v-model="this.receive_description" maxlength="400"
                                    class="form-control text-area-style" rows="2" style="width: 100% !important;"
                                    placeholder="give reason to remove the package">wel received</textarea>
                            </div>

                            <div v-if="loading" class="mt-1">
                                <div class="text-center">
                                    <div class="spinner-grow text-success" role="status"></div>
                                    <div class="spinner-grow text-danger" role="status"></div>
                                    <div class="spinner-grow text-warning" role="status"></div>
                                </div>
                            </div>

                            <button type="button" @click="receivePackage" class="btn btn-primary w-100 mt-3">Receive
                                Package</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--receiver -->
    <div class="modal fade mobile-full-width" id="deleteModal" tabindex="-1" data-bs-backdrop="static"
        data-bs-keyboard="false" role="dialog" aria-labelledby="deleteModal" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">

            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="font-weight-bold">Delete Parcels</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="container mt-3 mb-3">
                    <div class="row">

                        <div class="col-sm-12">
                            <h4 class="text-center mt-3">{{ parcel.name }}</h4>
                            <h5 id="">Sender : {{ parcel.sender_name }} - {{ parcel.sender_phone }}</h5>
                            <h5 id="">Receiver : {{ parcel.receiver_name }} - {{ parcel.receiver_phone }}</h5>
                        </div>

                        <div class="col-sm-12 col-md-12">
                            <div class="form-group">
                                <label class="form-label">Reason</label>
                                <textarea v-model="this.delete_description" maxlength="400"
                                    class="form-control text-area-style" rows="2" style="width: 100% !important;"
                                    placeholder="give reason to remove the package"></textarea>
                            </div>

                            <div v-if="loading" class="mt-1">
                                <div class="text-center">
                                    <div class="spinner-grow text-success" role="status"></div>
                                    <div class="spinner-grow text-danger" role="status"></div>
                                    <div class="spinner-grow text-warning" role="status"></div>
                                </div>
                            </div>

                            <button type="button" @click="deletePackage" class="btn btn-primary w-100 mt-3">Remove
                                Package</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--receipt-->
    <div class="modal fade mobile-full-width" id="receiptModal" tabindex="-1" data-bs-backdrop="static"
        data-bs-keyboard="false" role="dialog" aria-labelledby="receiptModal" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="container mt-3 mb-3">
                    <center>
                        <h3 class="mt-2 mb-3 head-text text-success">Package sent Successfully, You may Print Receipt
                        </h3>
                    </center>

                    <div class="" id="printThis">


                        <div class="pb-5" id="invoice-POS">
                            <center>
                                <!--img src="/images/new_logo.png" width="250px" alt="logo"-->
                                <h1>USIRI<br />
                                    TRANSIPORTATION<br />
                                    SERVICES LIMITED<br /> TIN 154-477-365
                                </h1>
                                <h5 id="pno"></h5>
                            </center>
                            <div>
                                <h5 id="pp"></h5>
                                <center>
                                    <img id="codedata-img" src="" alt="" srcset="">
                                </center>
                                <center>
                                    <p>TERMS & CONDITIONS</p>
                                    <p>Mizigo ya Kuvunjika na Vimiminika sio Dhamana yetu!<br />
                                        Endapo mzigo utapotea Kampuni italipa kulingana na Thamani
                                        iliyoandikwa kwenye Risiti tuu.
                                    </p>

                                    <p><br /></p>
                                    <p>Asante kwa kutuchagua<br>
                                        TRUST FIRST
                                    </p>
                                    <p id="ct"></p>
                                    <br />
                                    <p><i>Developed by Akilikubwa Digital<br>
                                            www.akilikubwadigital.com<br>
                                            <p>-----------------------</p>
                                        </i>
                                    </p>
                                    <br>
                                </center>

                            </div>

                        </div><!--End Invoice-->

                    </div>
                    <div>
                        <div v-if="loading" class="mt-1">
                            <div class="text-center">
                                <div class="spinner-grow text-success" role="status"></div>
                                <div class="spinner-grow text-danger" role="status"></div>
                                <div class="spinner-grow text-warning" role="status"></div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <button class="btn btn-primary" @click="printReceipt" id="on_print"><i
                                class="fa fa-printer"></i>Print</button>
                        <span class="m-3"> </span>
                        <button id="cancel" type="button" class="btn btn-danger" data-bs-dismiss="modal">
                            Cancel
                        </button>
                    </div>

                </div>

            </div>
        </div>
    </div>

    <!--pdf file-->
    <div class="modal fade mobile-full-width" id="pdfModal" tabindex="-1" data-bs-backdrop="static"
        data-bs-keyboard="false" role="dialog" aria-labelledby="pdfModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">

            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="font-weight-bold">Print On Transit Package</h4>
                    <button type="button" class="btn-close close_pdf" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="container mt-3 mb-3">
                    <div class="d-flex justify-content-between mb-3">
                        <p></p>
                        <div>
                            <!--button type="button" onclick="downloadCode();">Download HTML</button-->
                            <button class="btn btn-primary" @click="printManfestPdf" id="print_pdf"><i
                                    class="fa fa-print"></i> Print Pdf</button>
                            <!--button class="btn btn-danger text-white">Close</button-->
                        </div>
                    </div>

                    <div id="package_manfest">
                        <div class="mb-2">
                            <h1>Manifest List</h1>
                            <div class="d-flex justify-content-between">
                                <div>
                                    <h5>Company Name : Usiri Transportation</h5>
                                    <h5>Total Paid Amount : TSH
                                        <PriceFormat :Price="this.total_price" />
                                    </h5>
                                </div>
                                <div class="">
                                    <h5>TIN Number: ED TIN 154-477-365</h5>
                                    <h5>Total Cargo Value : TSH
                                        <PriceFormat :Price="total_value" />
                                    </h5>
                                </div>
                                <div></div>
                            </div>
                        </div>

                        <div id="reportbox" class="w-100">
                            <table class="table pdf-table table border">
                                <thead>
                                    <tr class="">
                                        <th>No</th>
                                        <th>Mtumaji</th>
                                        <th>Mtumaji No</th>
                                        <th>Mpokeaji</th>
                                        <th>Mpokeaji No </th>
                                        <th>Unakwenda</th>
                                        <th>Aina</th>
                                        <th>Remark</th>
                                    </tr>
                                </thead>
                                <tbody id="outgoing-list">


                                    <tr v-for="parcel, index in parcels" :key="parcel.id">

                                        <td v-if="parcel.package_size == 'S'"><span class="text-capitalize">{{ index +
                                                1}}</span> <span class="text-success text-small">[S]</span></td>
                                        <td v-else><span class="text-capitalize">{{ index + 1 }}</span> <span
                                                class="text-danger">[R]</span></td>

                                        <td class="text-capitalize">{{ parcel.sender_name }}</td>
                                        <td>{{ parcel.sender_phone }}</td>
                                        <td class="text-capitalize"> {{ parcel.receiver_name }} </td>
                                        <td> {{ parcel.receiver_phone }}</td>
                                        <td>{{ parcel.bname }}</td>

                                        <td class="text-capitalize">{{ parcel.package_tag }}</td>
                                        <td></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                        <div class="mt-5">
                            <h1></h1>
                            <div class="d-flex justify-content-between">
                                <div>
                                    <h5>Signature : .............................................</h5>
                                </div>
                                <div class="">
                                    printed at {{ this.current_time }}
                                </div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import axios from "axios";

import printJS from 'print-js';
import html2pdf from "html2pdf.js";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            contact_form: false,
            errors: "",
            phone_list: "",
            message: "",
            receive_description: "wel received",
            delete_description: "",
            tags: [],
            branches: [],
            og_branches: [],
            branch_from: 0,
            staff_id: 0,
            fdate: "",
            tdate: "",
            filter_branch: "",
            parcels: [],
            og_parcels: [],
            staffs: [],
            parcel: {},
            currentPage: 1,
            perPage: 40,
            current_time: "",
            total_price: 0,
            total_value: 0,
            user: this.$attrs.user
        };
    },
    methods: {

        async filterParcel() {

            this.loading = true

            var branch_id = this.branch_from
            var staff_id = this.staff_id
            var fdate = this.fdate
            var tdate = this.tdate

            var response = await axios
                .post(this.$store.state.api_url + "/filter-outgoing-parcels", { branch_id, staff_id, fdate, tdate })
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.loading = false

                this.parcels = response.data.parcels;
                this.og_parcels = response.data.parcels

            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }

        },

        async receivePackage() {

            this.loading = true

            var closed_description = this.receive_description
            var barcode_id = this.parcel.barcode_id
            var pid = this.parcel.id

            var response = await axios
                .post(this.$store.state.api_url + "/receive-package", { closed_description, barcode_id, pid, })
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.loading = false

                const modal = bootstrap.Modal.getOrCreateInstance(
                    document.getElementById("receiveModal")
                );

                modal.hide();

                document.getElementById('parcel_' + pid).remove()

            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }

        },
        printManfestPdf() {
            this.generatePDF();
            //this.downloadPDF()
            //setTimeout(function () { window.location = window.location; }, 30000);
        },
        getPdfModal() {

            if (this.parcels.length == 0) {
                alert("Filter Data Before Printing")
            }

            this.current_time = this.getCurrentDateTime()
            this.total_price = this.getTotal('price')
            this.total_value = this.getTotal('package_value')

            const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("pdfModal")
            );

            modal.show();
        },
        getCurrentDateTime() {
            const now = new Date();

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const day = String(now.getDate()).padStart(2, "0");

            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");
            const seconds = String(now.getSeconds()).padStart(2, "0");

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        getTotal(key) {
            return this.parcels.reduce((total, parcel) => {
                return total + (Number(parcel[key]) || 0);
            }, 0);
        },
        getReceiveParcel(parcel) {

            this.parcel = parcel

            const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("receiveModal")
            );

            modal.show();
        },
        async deletePackage() {


            var closed_description = this.delete_description
            var barcode_id = this.parcel.barcode_id
            var pid = this.parcel.id

            if (closed_description == "") {
                alert("Weka sababu ya kufuta mzigo")
                return true
            }

            if (closed_description.length < 6) {
                alert("Weka sababu kwa ufasaha zaidi")
                return true
            }

            this.loading = true

            var response = await axios
                .post(this.$store.state.api_url + "/delete-package", { closed_description, barcode_id, pid, })
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.loading = false

                this.delete_description = ""

                const modal = bootstrap.Modal.getOrCreateInstance(
                    document.getElementById("deleteModal")
                );

                modal.hide();

                document.getElementById('parcel_' + pid).remove()

                var message = response.data.message;
                this.$toast.success(message, { duration: 5000, dismissible: true });

            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }

        },

        async getReceiptPackage(parcel) {

            var id = parcel.id

            this.loading = true

            const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("receiptModal")
            );

            modal.show();

            var response = await axios
                .post(this.$store.state.api_url + "/parcel/print-receipt", { id })
                .catch((errors) => {
                    this.loading = false
                    modal.hide();
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.loading = false

                var parcel = response.data.parcel

                //console.log(parcel)

                var shipping_at = parcel.shipping_at.split('T')
                var arive_at = parcel.arive_at.split('T')

                var pp = "<br>"
                pp += "Route :" + parcel.bb_from_name + " - " + parcel.bb_to_name + "<br>"
                pp += "Shiping date :" + shipping_at[0] + "<br>"
                pp += "<br>"
                pp += "Sender name :" + parcel.sender_name + "<br>"
                pp += "Sender phone :" + parcel.sender_phone + "<br>"
                pp += "Receiver name :" + parcel.receiver_name + "<br>"
                pp += "Receiver phone :" + parcel.receiver_phone
                pp += "<br><br>"
                pp += "Package name :" + parcel.parcel_label + "<br>"
                //pp += "Package weight :"+parcel.package_weight+"kg<br>"
                pp += "Package value :TSH " + parcel.package_value + ".00<br>"
                pp += "Package size :" + parcel.package_size + "<br>"
                pp += "Package type :" + parcel.package_tag
                pp += "<br><br>"
                pp += "Paid amount :TSH " + parcel.price + ".00"
                pp += "<br><br>"
                pp += "Issued by<br>"
                pp += "Name :" + parcel.fulname + "<br>"
                pp += "Phone :" + parcel.phone1 + "<br><br>"
                //pp += "Company phone :0769850631<br>"
                //pp += "CUSTOMER SERVICES :0752129251<br>"
                pp += "" + parcel.bb_from_name + " :" + parcel.bb_from_contact + "<br>"
                pp += "" + parcel.bb_to_name + " :" + parcel.bb_to_contact + "<br>"


                $('#pno').text("Parcel No :" + parcel.id)
                $('#ct').text(parcel.current_time)
                $('#pp').html(pp)
                $('#codedata-img').attr('src', parcel.code_data)

            } else {
                this.loading = false
                modal.hide();
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }

        },

        getDeleteParcel(parcel) {

            this.parcel = parcel

            const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("deleteModal")
            );

            modal.show();
        },
        showSMSForm() {
            this.contact_form = !this.contact_form
        },

        async getOtherBranch() {

            var response = await axios
                .get(this.$store.state.api_url + "/branch/other-branches")
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.branches = [{ id: 0, name: "All Branches" }, ...response.data.branches];
                this.og_branches = [{ id: 0, name: "All Branches" }, ...response.data.branches];

            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

        async getParcels() {

            this.loading = true

            var response = await axios
                .get(this.$store.state.api_url + "/web/outgoing-parcels")
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                this.loading = false

                this.parcels = response.data.parcels;
                this.staffs = [{ id: 0, fulname: "All Staffs" }, ...response.data.staffs];

                this.og_parcels = response.data.parcels

                /// console.log(this.parcels)

            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

        printReceipt() {
            printJS({
                printable: 'printThis',
                type: 'html',
                targetStyles: ['*'], // note: targetStyles (plural)
                style: `
                #invoice-POS {
                    width: 80mm;
                }

                #pp {
                    font-family: rockwell;
                    font-size: 30px;
                }

                @page {
                    margin: 0;
                    size: 80mm auto;
                }

                @media print {
                    body {
                        margin: 0;
                        width: 100%;
                        height: auto;
                        font-size: 20px;
                    }
                }
            `
            });
        },

        generatePDF() {

            var reff = Math.floor(10000 + Math.random() * 90000)
            const element = document.getElementById("package_manfest");
            //document.getElementById("reportbox").style.display = "block";
            //document.getElementById("reportbox").style.marginTop = "0px"; 
            //document.getElementById("package_manfest").style.border = "1px solid black";
            var opt = {
                margin: 0.3,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' }
            };
            html2pdf().set(opt).from(element).save('manifest_document_' + reff + '.pdf');
        },

        downloadPDF() {
            const element = document.getElementById("package_manfest");

            var reff = Math.floor(10000 + Math.random() * 90000)

            const options = {
                margin: 0,
                filename: 'manifest_document_' + reff + '.pdf',
                image: {
                    type: "jpeg",
                    quality: 0.98
                },
                html2canvas: {
                    scale: 2,
                    useCORS: true
                },
                jsPDF: {
                    unit: "mm",
                    format: "a4",
                    orientation: "portrait"
                }
            };

            html2pdf()
                .set(options)
                .from(element)
                .save();
        }

        ,
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++
            }
        },

        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--
            }
        },

        addPhoneList(phone) {

            this.contact_form = true
            // Convert string to array and remove empty values
            let phones = this.phone_list
                ? this.phone_list.split(",").map(p => p.trim()).filter(Boolean)
                : [];

            // Check if phone already exists
            const index = phones.indexOf(phone);

            if (index !== -1) {
                if (confirm(`${phone} already exists.\n\nDo you want to remove it?`)) {
                    phones.splice(index, 1);
                } else {
                    return;
                }
            } else {
                phones.push(phone);
            }

            // Convert back to comma-separated string
            this.phone_list = phones.join(",");
        },
        clearPhoneList() {
            this.phone_list = ""
        },
        async sendSms() {

            this.loading = true

            var phone_list = this.phone_list
            var message = this.message

            var response = await axios
                .post(this.$store.state.api_url + "/send-multi-sms", { phone_list, message })
                .catch((errors) => {
                    this.loading = false
                    var message_ = "Network or Server Errors";
                    this.$toast.error(message_, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                this.loading = false

                var message_ = response.data.message;
                this.$toast.success(message_, { duration: 5000, dismissible: true });

                this.phone_list = ""
                this.message = ""

            } else {

                this.loading = false
                var message_ = response.data.message;
                this.$toast.error(message_, { duration: 5000, dismissible: true });
            }
        }

    },
    computed: {

        paginatedParcels() {
            const start = (this.currentPage - 1) * this.perPage
            const end = start + this.perPage

            return this.parcels.slice(start, end)
        },

        totalPages() {
            return Math.ceil(this.parcels.length / this.perPage)
        },


    },
    watch: {

        filter_branch(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.branches = this.og_branches
                return
            }

            this.branches = this.og_branches.filter(branch => {

                return (
                    (branch.name && branch.name.toLowerCase().includes(term)) ||
                    (branch.region && branch.region.toLowerCase().includes(term))
                )

            })

        }
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getOtherBranch()
        this.getParcels()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
